export const STATUS = {
  status_new: 'status_new',
  status_validated: 'status_validated',
  status_not_uploaded: 'status_not_uploaded',
  status_uploading: 'status_uploading',
  status_pending_next_face: 'status_pending_next_face',
  status_close_to_expire: 'status_close_to_expire',
  status_expired: 'status_expired',
  status_invalid: 'status_invalid',
  status_error: 'status_error'
};

export const STATUS_TAG_COLORS = {
  status_new: 'green',
  status_validated: 'grey',
  status_not_uploaded: 'yellow',
  status_uploading: 'blue',
  status_pending_next_face: 'blue',
  status_close_to_expire: 'yellow',
  status_expired: 'red',
  status_invalid: 'red',
  status_error: 'red'
};

export const MAX_FILE_SIZE = 1024 * 15 * 1000; // 15MB;
